export default {
  s3: {
    REGION: 'eu-west-1',
    BUCKET: process.env.VUE_APP_S3_BUCKET
  },
  apiGateway: {
    REGION: 'eu-west-1',
    URL: process.env.VUE_APP_API_URL
  },
  cognito: {
    REGION: 'eu-west-1',
    USER_POOL_ID: process.env.VUE_APP_USER_POOL_ID,
    APP_CLIENT_ID: process.env.VUE_APP_CLIENT_ID,
    IDENTITY_POOL_ID: process.env.VUE_APP_IDENTITY_POOL_ID
  }
}
